var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bb-technical-support",class:[_vm.isFounder && 'bb-technical-support_founder'],on:{"click":_vm.onOpenModal}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.buildIcon)}}),_vm._v("\n  Technical support\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33dfd9f0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TechnicalSupport/TechnicalSupportButton/TechnicalSupportButton.vue
// module id = null
// module chunks = 